import React from "react";
import { css, cx } from 'emotion';
import { gridGutter, gridGutterHalf, gridGutter1q6, fontSize16, borderRadiusBase } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import { blue, grayBorder, white } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";
import { Card } from "@maxmilhas/hangar-components-atomic/public";
import { formatCurrency } from "../../../shared/utils";

const container = css`
    position: relative;
`;
const divider = css`
    border: .5px solid ${grayBorder};
    margin: 0;
    margin-bottom: ${gridGutter1q6}px;
    margin-left: -${gridGutter}px;
    margin-right: -${gridGutter}px;
`;

const purchaseTitle = css`
  font-weight: 500;
  font-size: ${fontSize16};
  color: ${blue};
`;

const purchaseDescription = css`
    display: inline;
    font-weight: 500;

    @media screen and (max-width: 767px) {
        display: block;   
    }
`;

const purchaseValue = css`
    font-weight: bold;
    color: ${blue};
    position: absolute;
    right: ${gridGutterHalf}px;
    font-size: ${fontSize16};

    @media screen and (max-width: 480px) {
        position: relative;
        right: 0;
    }
`;

const row = css`
    display: flex;
    flex-direction: row;
    padding: ${gridGutterHalf}px;

    @media screen and (max-width: 480px) {
        display: flex;
        flex-direction: column;
        text-align: center;
    }

    &:first-child {
        margin-top: -${gridGutterHalf}px;
    }

    &:last-child {
        margin-left: -${gridGutter}px;
        margin-right: -${gridGutter}px;
        margin-bottom: -${gridGutter}px;
        background-color: ${blue};
        border-bottom-left-radius: ${borderRadiusBase || '4px' };
        border-bottom-right-radius: ${borderRadiusBase || '4px' };

        label {
            padding-left: ${gridGutter}px;
        }

        label, span {
            color: ${white};
            font-weight: bold;
        }
    }
`;

function DetailsPurchaseResume ({ purchase }) {
    const { order: { billing: { value: purchasePrice, installments }, fee, boardingTax, luggagePrice }} = purchase;
    const installmentsFormated = installments > 0 ? `parcelado em ${installments}x` : 'à vista';
    return (
       <Card>
           <div className={container}>
                <div className={row}>
                    <label className={purchaseTitle}>
                        Valor pago
                    </label>
                    <span className={purchaseValue}>{formatCurrency(purchasePrice)}</span>
                </div>
                <hr className={divider}/>
                <div className={row}>
                    <label className={purchaseTitle}>
                       Taxa de serviço
                    </label>
                    <span className={purchaseValue}>{formatCurrency(fee)}</span>
                </div>
                <hr className={divider}/>
                <div className={row}>
                    <label className={purchaseTitle}>
                       Taxa de embarque
                    </label>
                    <span className={purchaseValue}>{formatCurrency(boardingTax)}</span>
                </div>  
                <hr className={divider}/>              
                <div className={row}>
                    <label className={purchaseTitle}>
                       Bagagem despachada
                    </label>
                    <span className={purchaseValue}>{formatCurrency(luggagePrice)}</span>
                </div>                
                <div className={row}>
                    <label className={purchaseTitle}>
                       Valor total na MaxMilhas <p className={purchaseDescription}>({installmentsFormated})</p>
                    </label>
                    <span className={purchaseValue}>{formatCurrency(purchasePrice)}</span>
                </div>                
            </div>
       </Card>
    )
}

export default DetailsPurchaseResume;